import {getEventId} from '@wix/wix-events-commons-statics'
import {membersPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import React from 'react'
import {isTicketedWithNoOrder} from '../../../selectors/event'
import {downloadTickets, downloadTicketsWithNoOrder} from '../../../services/tickets'
import {EventLink} from '../../styled-components/event-link'
import {MobileDownloadTicketsButtonProps} from '.'

export const MobileDownloadTicketsButton: React.FC<MobileDownloadTicketsButtonProps> = ({
  event,
  tickets,
  t,
  downloadTicketsAction,
  order,
}) => {
  const eventId = getEventId(event.event)
  const ticketedWithNoOrder = isTicketedWithNoOrder(event)
  const eventTickets = tickets[eventId]

  const handleEventLinkClick = () => {
    ticketedWithNoOrder ? downloadTicketsWithNoOrder(eventTickets) : downloadTickets(order)

    downloadTicketsAction(eventId)
  }

  return (
    <EventLink
      secondary={true}
      mobile={true}
      onClick={handleEventLinkClick}
      data-hook={DH.MOBILE_BUTTON_DOWNLOAD_TICKETS}
    >
      {t('events.buttons.download-tickets')}
    </EventLink>
  )
}
